// Fixed AdminDashboard component with proper route rendering
import React, { Suspense, useEffect, useState } from "react";
import { Portal, Box, useDisclosure, Flex, Icon } from "@chakra-ui/react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Import all route collections
import newRoutes from "common/routes.js";
import { vaultRoutes, homeRoutes, commonRoutes, recruitmentRoutes, departmentRoutes } from "common/routes";
import { ROLE_PATH } from "../../common/roles";

// Components
import Footer from "common/components/footer/FooterAdmin.js";
import Navbar from "common/components/navbar/NavbarAdmin.js";
import Sidebar from "common/components/sidebar/Sidebar.js";
import { SidebarContext } from "common/contexts/SidebarContext";
import FilterSidebar from "common/components/filterSidebar/FilterSidebar";
import DynamicPage from "common/components/dynamicPage";
import DynamicPageview from "common/components/dynamicPage/DynamicPageview";
import CreateDynamic from "common/components/dynamicPage/create";

// Redux
import { fetchImage } from "../../common/redux/reducers/imageSlice";
import { fetchRouteData } from "../../common/redux/reducers/routeSlice";

// Icons
import { LuChevronRightCircle } from "react-icons/lu";

export default function AdminDashboard(props) {
  const { ...rest } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const route = useSelector((state) => state?.route?.data);

  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [openSidebar, setOpenSidebar] = useState(false);
  const [openSubBar, setOpenSubBar] = useState(true);
  const [organizedRoutes, setOrganizedRoutes] = useState([]);
  const [routes, setRoutes] = useState(homeRoutes);

  const user = JSON.parse(localStorage.getItem("user")) || {};

  const [subRoute, setSubRoute] = useState(
    location.pathname === "/home"
      ? []
      : location.pathname.split("/").includes("crm")
        ? newRoutes
        : location.pathname.split("/").includes("password")
          ? vaultRoutes
          : location.pathname.split("/").includes("recruit")
            ? recruitmentRoutes
            : commonRoutes
  );

  const pathName = (name) => {
    return `/crm/${name.replace(/ /g, "-")}`;
  };

  const dynamicRoute = (initialSubRoute) => {
    let apiData = [];
    const updatedSubRoute = subRoute.length > 0 ? subRoute : initialSubRoute;

    route &&
      route?.length > 0 &&
      route?.map((item, i) => {
        let rec = updatedSubRoute.find(
          (route) => route?.name === item?.moduleName
        );

        if (!updatedSubRoute.some((route) => route?.name === item?.moduleName)) {
          const newRoute = [
            {
              name: item?.moduleName.replace(/-/g, " "),
              layout: [ROLE_PATH.superAdmin],
              path: pathName(item.moduleName),
              icon: item?.icon ? (
                <img src={item?.icon} width="20px" height="20px" alt="icon" />
              ) : (
                <Icon
                  as={LuChevronRightCircle}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              component: DynamicPage,
            },
            {
              name: item?.moduleName.replace(/-/g, " "),
              layout: [ROLE_PATH.superAdmin],
              under: item?.moduleName,
              parentName: item?.moduleName.replace(/-/g, " "),
              path: `${pathName(item.moduleName)}/:id`,
              icon: item?.icon ? (
                <img src={item?.icon} width="20px" height="20px" alt="icon" />
              ) : (
                <Icon
                  as={LuChevronRightCircle}
                  width="20px"
                  height="20px"
                  color="inherit"
                />
              ),
              component: DynamicPageview,
            },
            {
              name: item?.moduleName.replace(/-/g, " "),
              layout: [ROLE_PATH.superAdmin],
              under: item?.moduleName,
              parentName: item?.moduleName.replace(/-/g, " "),
              path: `${pathName(item.moduleName)}/create`,
              component: CreateDynamic,
            },
          ];
          setSubRoute((pre) => [...pre, ...newRoute]);
        } else if (
          updatedSubRoute.some((route) => route?.name === item?.moduleName) &&
          rec.icon?.props?.src !== item?.icon
        ) {
          const updatedData = updatedSubRoute?.map((i) => {
            if (i.name === item?.moduleName) {
              return {
                ...i,
                icon: (
                  <img src={item?.icon} width="20px" height="20px" alt="icon" />
                ),
              };
            }
            return i;
          });
          setSubRoute(updatedData);
        }

        if (updatedSubRoute.find((route) => route?.name !== item?.moduleName)) {
          if (!newRoutes.find((route) => route?.name?.toLowerCase() === item?.moduleName?.toLowerCase())) {
            const newRoute = [
              {
                name: item?.moduleName.replace(/-/g, " "),
                layout: [ROLE_PATH.superAdmin],
                path: pathName(item.moduleName),
                icon: item?.icon ? (
                  <img src={item?.icon} width="20px" height="20px" alt="icon" />
                ) : (
                  <Icon
                    as={LuChevronRightCircle}
                    width="20px"
                    height="20px"
                    color="inherit"
                  />
                ),
                component: DynamicPage,
              },
              {
                name: item?.moduleName.replace(/-/g, " "),
                layout: [ROLE_PATH.superAdmin],
                under: item?.moduleName,
                parentName: item?.moduleName.replace(/-/g, " "),
                path: `${pathName(item.moduleName)}/:id`,
                icon: item?.icon ? (
                  <img src={item?.icon} width="20px" height="20px" alt="icon" />
                ) : (
                  <Icon
                    as={LuChevronRightCircle}
                    width="20px"
                    height="20px"
                    color="inherit"
                  />
                ),
                component: DynamicPageview,
              },
              {
                name: item?.moduleName.replace(/-/g, " "),
                layout: [ROLE_PATH.superAdmin],
                under: item?.moduleName,
                parentName: item?.moduleName.replace(/-/g, " "),
                path: `${pathName(item.moduleName)}/create`,
                component: CreateDynamic,
              },
            ];
            apiData.push(...newRoute);
          }
        }
      });

    let filterData = [...newRoutes, ...apiData];
    const accountsItems = filterData.filter((item) => item.name === "Accounts");
    const dealsItems = filterData.filter((item) => item.name === "Deals");
    const remainingItems = filterData.filter(
      (item) => item.name !== "Accounts" && item.name !== "Deals"
    );

    const propertiesIndex = remainingItems.findIndex(
      (item) => item.name?.trim() === "Products"
    );

    let reorderedData = [...remainingItems];
    if (propertiesIndex !== -1) {
      reorderedData.splice(propertiesIndex, 0, ...accountsItems, ...dealsItems);
    } else {
      reorderedData.push(...accountsItems, ...dealsItems);
    }

    setSubRoute(reorderedData);
    localStorage.setItem("crmSubRoute", JSON.stringify(reorderedData));
  };


  const organizeAllAdminRoutes = () => {
    if (location.pathname === "/home") {
      return [];
    }

    const storedSubRoute = localStorage.getItem("crmSubRoute");
    const crmRoutes = storedSubRoute ? JSON.parse(storedSubRoute) : newRoutes;

    const getRoute = (routeName, routeCollection) => {
      return routeCollection.find(route =>
        route.name === routeName && route.path && !route.under
      );
    };

    const getSubRoutes = (parentName, routeCollection) => {
      return routeCollection.filter(route => {
        if (parentName === "My Passwords") {
          return route.under === "password/my-password";
        }
        if (parentName === "Shared With Me") {
          return route.under === "/password/share-with-me";
        }
        if (parentName === "Shared By Me") {
          return route.under === "/password/share-by-me";
        }
        return (route.parentName === parentName && route.under);
      });
    };

    const organized = [];


    const overviewRoute = getRoute("Overview", crmRoutes);
    if (overviewRoute) {
      organized.push({
        name: "Get Started",
        path: overviewRoute.path,
        layout: overviewRoute.layout,
        component: overviewRoute.component,
        icon: null
      });
    }


    // 1. CRM - Main section with Dashboard as first item
    const crmSubRoutes = [];

    const homeRoute = getRoute("Home", crmRoutes);
    if (homeRoute) {
      crmSubRoutes.push({
        ...homeRoute,
        name: "Dashboard",
        icon: null
      });
    }

    const crmMainRoutes = ["Leads", "Contacts", "Accounts", "Deals"];
    crmMainRoutes.forEach(routeName => {
      const route = getRoute(routeName, crmRoutes);
      if (route) {
        crmSubRoutes.push({
          ...route,
          icon: null
        });
      }
    });

    const taskRoute = getRoute("Tasks", crmRoutes);
    if (taskRoute) {
      crmSubRoutes.push({
        ...taskRoute,
        name: "Tasks",
        icon: null
      });
    }

    const dynamicRoutes = crmRoutes.filter(route =>
      !["Home", "Overview", "Dashboard", "Leads", "Contacts", "Accounts", "Deals", "Tasks", "Meetings", "Calls", "Emails", "Calendar", "Reporting & Analytics", "Workflow Rules", "Support", "Products"].includes(route.name) &&
      !route.under &&
      route.path &&
      !route.name.toLowerCase().includes('signin') &&
      !route.name.toLowerCase().includes('sign in') &&
      !route.name.toLowerCase().includes('login') &&
      !route.name.toLowerCase().includes('forgot') &&
      !route.name.toLowerCase().includes('reset') &&
      !route.name.toLowerCase().includes('password') &&
      !route.name.toLowerCase().includes('auth') &&
      !route.name.toLowerCase().includes('product') &&
      !route.name.toLowerCase().includes('inventory') &&
      !route.name.toLowerCase().includes('catalog')
    );

    dynamicRoutes.forEach(route => {
      crmSubRoutes.push({
        ...route,
        icon: null
      });
    });

    const productsRoute = getRoute("Products", crmRoutes);
    if (productsRoute) {
      crmSubRoutes.push({
        ...productsRoute,
        name: "Products",
        icon: null
      });
    } else {
      // Look for product-related dynamic routes
      const productDynamicRoutes = crmRoutes.filter(route =>
        route.name && route.component && route.path && (
          route.name.toLowerCase().includes('product') ||
          route.name.toLowerCase().includes('inventory') ||
          route.name.toLowerCase().includes('catalog')
        ) && !route.under
      );

      productDynamicRoutes.forEach(route => {
        if (route.component && route.path) {
          crmSubRoutes.push({
            name: route.name,
            path: route.path,
            layout: route.layout || [ROLE_PATH.superAdmin],
            component: route.component,
            icon: null
          });
        }
      });
    }

    // Create CRM dropdown
    if (crmSubRoutes.length > 0) {
      organized.push({
        name: "CRM", // Changed from "Dashboard" to "CRM"
        subRoutes: crmSubRoutes
      });
    }

    // 2. Activities - Show ALL activity routes
    const activityRoutes = [];
    ["Meetings", "Calls", "Emails"].forEach(routeName => {
      const route = getRoute(routeName, crmRoutes);
      if (route) {
        activityRoutes.push({
          ...route,
          icon: null
        });
      }
    });

    // Calendar is always part of activities
    const calendarRoute = getRoute("Calendar", crmRoutes);
    if (calendarRoute) {
      activityRoutes.push({
        ...calendarRoute,
        icon: null
      });
    }

    if (activityRoutes.length > 0) {
      organized.push({
        name: "Activities",
        subRoutes: activityRoutes
      });
    }

    // 3. Workflow Status Summary (renamed from Workflow Rules)
    const workflowRoute = getRoute("Workflow Rules", crmRoutes);
    if (workflowRoute) {
      organized.push({
        name: "Workflows",
        path: workflowRoute.path,
        layout: workflowRoute.layout,
        component: workflowRoute.component,
      });
    }

    // 4. Reporting - Always show
    const reportingRoute = getRoute("Reporting & Analytics", crmRoutes);
    if (reportingRoute) {
      organized.push({
        name: "Reports",
        path: reportingRoute.path,
        layout: reportingRoute.layout,
        component: reportingRoute.component,
      });
    }

    organized.push({
      name: "separator-password",
      isSeparator: true,
      separatorText: ""
    });


    // 5. Password Section - Always show
    const passwordMainRoutes = [];
    ["My Passwords", "Shared With Me", "Shared By Me"].forEach(routeName => {
      const route = getRoute(routeName, vaultRoutes);
      if (route) {
        const subroutes = getSubRoutes(routeName, vaultRoutes);
        passwordMainRoutes.push({
          ...route,
          icon: null,
          subRoutes: subroutes.length > 0 ? subroutes.map(sr => ({
            ...sr,
            icon: null
          })) : undefined
        });
      }
    });

    if (passwordMainRoutes.length > 0) {
      organized.push({
        name: "Password Manager",
        subRoutes: passwordMainRoutes
      });
    }


    return organized;
  };
  useEffect(() => {
    const storedSubRoute = localStorage.getItem("crmSubRoute");
    if (location.pathname === "/home") {
      setSubRoute([]);
    } else if (location.pathname.split("/").includes("crm")) {
      const initialSubRoute = storedSubRoute ? JSON.parse(storedSubRoute) : newRoutes;
      dynamicRoute(initialSubRoute);
      setSubRoute(initialSubRoute);
    } else if (location.pathname.split("/").includes("password")) {
      setSubRoute(vaultRoutes);
    } else if (location.pathname.split("/").includes("recruit")) {
      setSubRoute(recruitmentRoutes);
    } else {
      setSubRoute(commonRoutes);
    }
  }, [location.pathname]);

  useEffect(() => {
    const initialSubRoute =
      location.pathname === "/home"
        ? []
        : location.pathname.split("/").includes("crm")
          ? newRoutes
          : location.pathname.split("/").includes("password")
            ? vaultRoutes
            : location.pathname.split("/").includes("recruit")
              ? recruitmentRoutes
              : commonRoutes;
    if (location.pathname.includes("crm")) dynamicRoute(initialSubRoute);
  }, [route, location.pathname]);

  useEffect(() => {
    const routes = organizeAllAdminRoutes();
    setOrganizedRoutes(routes);
  }, [location.pathname, subRoute]);

  const getRoute = () => window.location.pathname !== "/admin/full-screen-maps";

  const defaultRoute = [
    "crm/default", "recruit/dashboard", "crm/contactView", "crm/leadView", "/home"
  ].some((path) => location.pathname.includes(path));

  const topRoute = [
    "/recruit/candidate", "/recruit/jobProfileCreate", "recruit/InterviewCreate",
    "recruit/jobApplicationCreate", "recruit/createCandidate", "recruit/departmentCreate",
    "recruit/offerLetterCreate"
  ].some((path) => location.pathname.includes(path));

  // Helper functions for navbar
  const getActiveRoute = (routes) => {
    let activeRoute = "pulseCRM pro";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].path.replace("/:id", "")) !==
          -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  const under = (routes) => {
    let activeRoute = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].path.replace("/:id", "")) !==
          -1
        ) {
          return routes[i];
        }
      }
    }
    return activeRoute;
  };

  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (window.location.href.indexOf(routes[i].path) !== -1) {
          return routes[i].secondary;
        }
      }
    }
    return activeNavbar;
  };

  const getActiveNavbarText = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (window.location.href.indexOf(routes[i].path) !== -1) {
          return routes[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };

  const getRoutes = (routes) => {
    if (!routes || routes.length === 0) {
      console.warn("No routes provided to getRoutes");
      return [];
    }

    const routeElements = [];

    // Process each route
    routes.forEach((prop, key) => {
      if (!prop) return;

      if (prop.component && prop.path) {
        const shouldRender = !prop.layout ||
          prop.layout.includes(ROLE_PATH.superAdmin) ||
          prop.layout.includes(ROLE_PATH.user);

        if (shouldRender) {
          const routeKey = `${prop.name}-${key}-${prop.path}`.replace(/[^a-zA-Z0-9-_]/g, '');

          routeElements.push(
            <Route
              key={routeKey}
              path={prop.path}
              element={
                <Suspense fallback={<div>Loading {prop.name}...</div>}>
                  <prop.component />
                </Suspense>
              }
            />
          );
        }
      }

      if (prop.collapse && prop.items) {
        routeElements.push(...getRoutes(prop.items));
      }

      if (prop.category && prop.items) {
        routeElements.push(...getRoutes(prop.items));
      }

      if (prop.subRoutes && Array.isArray(prop.subRoutes)) {
        routeElements.push(...getRoutes(prop.subRoutes));
      }
    });

    return routeElements;
  };

  // Initialize data
  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(fetchRouteData());
        await dispatch(fetchImage());
      } catch (error) {
        console.error("Error dispatching actions:", error);
      }
    };
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    if (openSubBar) {
      document.body.classList.add('openSidebar');
    } else {
      document.body.classList.remove('openSidebar');
    }
    return () => document.body.classList.remove('openSidebar');
  }, [openSubBar]);

  const largeLogo = useSelector((state) =>
    state?.images?.image?.filter((item) => item.isActive === true)
  );

  const { onOpen } = useDisclosure();
  document.documentElement.dir = "ltr";

  return (
    <Box>
      <SidebarContext.Provider value={{ toggleSidebar, setToggleSidebar }}>
        <Sidebar
          organizedRoutes={organizedRoutes}
          routes={routes}
          subRoute={subRoute}
          isUserLayout={false}
          largeLogo={largeLogo}
          display="none"
          openSubBar={openSubBar}
          setOpenSubBar={setOpenSubBar}
          openSidebar={openSidebar}
          setOpenSidebar={setOpenSidebar}
          {...rest}
        />
        <FilterSidebar />

        <Box
          className="dash-cont"
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={{
            base: "100%",
            xl: openSidebar === true
              ? "calc( 100% - 300px )"
              : openSubBar === true
                ? "calc( 100% - 500px )"
                : !openSidebar && !openSubBar
                  ? "calc( 100% - 88px )"
                  : "calc( 100% - 200px )",
          }}
          maxWidth={{
            base: "100%",
            xl: openSidebar === true
              ? "calc( 100% - 300px )"
              : openSubBar === true
                ? "calc( 100% - 500px )"
                : !openSidebar && !openSubBar
                  ? "calc(100% - 150px)"
                  : "calc( 100% - 200px )",
          }}
          transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
          transitionDuration=".2s, .2s, .35s"
          transitionProperty="top, bottom, width"
          transitionTimingFunction="linear, linear, ease"
        >
          <Portal>
            <Box className="header">
              <Navbar
                isUserLayout={false}
                onOpen={onOpen}
                logoText={"Horizon UI Dashboard PRO"}
                brandText={getActiveRoute(subRoute)}
                secondary={getActiveNavbar(subRoute)}
                message={getActiveNavbarText(subRoute)}
                routes={routes}
                organizedRoutes={organizedRoutes}
                subRoute={subRoute}
                fixed={fixed}
                under={under(subRoute)}
                largeLogo={largeLogo}
                openSubBar={openSubBar}
                setOpenSubBar={setOpenSubBar}
                openSidebar={openSidebar}
                setOpenSidebar={setOpenSidebar}
                {...rest}
              />
            </Box>
          </Portal>

          <Box
            pt={{ base: "150px", md: "95px", xl: "95px" }}
            className={`main-content ${defaultRoute ? "defaultPage" : ""} ${topRoute ? "ptNormal" : ""}`}
          >
            {getRoute() && (
              <Box
                mx="auto"
                pe="20px"
                w="50%"
                minH="84vh"
                pt="50px"
                style={{ padding: openSidebar ? "8px 20px 8px 20px" : "8px 20px" }}
              >
                <Suspense
                  fallback={
                    <Flex justifyContent="center" alignItems="center" width="100%">
                      {/* <Spinner /> */}
                    </Flex>
                  }
                >
                  <Routes>
                    {getRoutes(
                      location.pathname === "/home"
                        ? homeRoutes
                        : subRoute
                    )}
                    <Route path="/superAdmin" element={<Navigate to="/crm/default" />} />
                  </Routes>
                </Suspense>
              </Box>
            )}
          </Box>

          <Box>
            <Footer />
          </Box>
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}